// extracted by mini-css-extract-plugin
export var searchHeader = "_27-0";
export var searchHeaderDark = "_27-1";